<div
  class="fixed inset-0 z-50 bg-black/60 transition-opacity duration-200 ease-in-out"
  [ngClass]="{
    'opacity-100': open(),
    'pointer-events-none opacity-0': !open()
  }"
  (click)="close($event)">
  <div
    class="bg-bg-base absolute bottom-0 left-0 w-full transition-transform duration-200 ease-in-out"
    [ngClass]="{
      'translate-y-0': open(),
      'translate-y-full': !open()
    }"
    (click)="$event.stopPropagation()"
    style="max-height: 80vh">
    <div
      (click)="close()"
      class="modal-handle">
      <div class="handle-bar"></div>
    </div>

    <div class="max-h-[calc(80vh-35px)] overflow-y-auto px-6 pt-8 pb-6">
      <ng-content></ng-content>
    </div>
  </div>
</div>
